<template>
<v-card>
    <v-card-title class="subtitle-1">
        <v-icon color="pink lighten-3" class="mr-3">mdi-comment-question</v-icon>1:1 문의
    </v-card-title>
    <v-card-text class="pa-0">
        <v-divider />
        <v-data-table :headers="questionsHeaders" :items="questions" disable-sort disable-pagination hide-default-footer>
            <template v-slot:item.product="{ item }">
                <v-row v-if="item.product" align="center">
                    <v-col md="auto">
                        <v-img v-if="item.product.thumb" :src="item.product.thumb" max-width="56" max-height="56"></v-img>
                        <v-responsive v-else width="56" height="56">
                            <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                <v-icon>mdi-image</v-icon>
                            </v-row>
                        </v-responsive>
                    </v-col>
                    <v-col>
                        <div class="text-start">{{ item.product.name }}</div>
                    </v-col>
                </v-row>
                <v-row v-else align="center">
                    <v-col md="auto">
                        <v-responsive width="56" height="56">
                            <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                <v-icon>mdi-image</v-icon>
                            </v-row>
                        </v-responsive>
                    </v-col>
                    <v-col>
                        <div class="text-start">삭제된 상품</div>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:item.user="{ item }">
                <v-row v-if="item.user">
                    <v-col>{{ item.user.name }}({{ item.user.username }})</v-col>
                </v-row>
                <v-row v-else>
                    <v-col>탈퇴회원</v-col>
                </v-row>
            </template>

            <template v-slot:item.createDate="{ item }">
                {{ item.createDate.toDate() }}
            </template>

            <template v-slot:item.reply="{ item }">
                <span v-if="item.reply">답변완료</span>
                <span v-else>미답변</span>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon small @click="edit(item)">mdi-pencil</v-icon>
            </template>

        </v-data-table>

        <v-dialog v-model="dialog" max-width="720px">
            <v-card v-if="dialog">
                <v-card-title>
                    <span class="subtitle-1">상품문의</span>
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="editItem.subject" label="문의 제목" placeholder=" " readonly dense hide-details class="mt-3"></v-text-field>
                    <v-text-field label="문의날짜" placeholder=" " readonly dense hide-details :value="editItem.createDate.toDate()" class="mt-6"></v-text-field>
                    <v-text-field label="작성자" placeholder=" " readonly dense hide-details :value="editItem.user ? `${editItem.user.name}(${editItem.user.username})` : '탈퇴회원'" class="mt-6"></v-text-field>
                    <v-textarea v-model="editItem.content" label="문의 내용" placeholder=" " readonly dense hide-details class="mt-6"></v-textarea>
                    <v-textarea v-model="editItem.reply" label="답변" placeholder=" " dense hide-details class="mt-6"></v-textarea>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="close">취소</v-btn>
                    <v-btn color="primary" text @click="save">저장</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-card-text>
</v-card>
</template>

<script>
import api from "@/api";
export default {
    data() {
        return {
            dialog: false,

            editItem: null,

            questions: [],
            questionsHeaders: [{
                text: '문의내용',
                align: 'center',
                value: 'subject'
            }, {
                text: '작성일자',
                align: 'center',
                width: 170,
                value: 'createDate'
            }, {
                text: 'Actions',
                align: 'center',
                width: 96,
                value: 'actions'
            }],
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            try {
                var {
                    questions
                } = await api.console.center.questions.getQuestions({
                    headers: {
                        skip: 0,
                        limit: 5
                    }
                });

                this.questions = questions;
            } catch (error) {
                console.error(error);
            }
        },
        edit(question){
            this.editItem = Object.assign({}, question);
            this.dialog = true;
        },

        close(){
            this.dialog = false;
        },
        async save(){
            try{
                await api.console.center.questions.putQuestion(this.editItem);
                await this.search();
                alert("저장되었습니다");
                this.dialog = false;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    }
}
</script>
